<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<template>
  <v-progress
    v-if="loadingTotal !== loadingCurrent"
    :model-value="loadingPercent"
    label="loading"
    color="accent"
    class="toolbar"
  />
  <v-skeleton-loader
    v-if="appStore.loading"
    type="card"
    width="100%"
    height="100%"
    style="justify-content: center;"
  />
  <v-sheet
    v-else
    class="ma-0 pa-0"
  >
    <div align="center">
      <v-fab
        icon="fasldr fa-angle-left"
        location="left"
        @click="prevPage"
      />
      <VuePDF
        ref="VPDF"
        :page="appStore.currentPage"
        :pdf="pdf"
        :width="mobile ? getWidth : undefined"
        :height="mobile ? undefined : getHeight"
        annotation-layer
        hide-forms
        @loaded="onPdfLoaded"
        @click="nextPage"
      />
      <v-fab
        icon="fasldr fa-angle-right"
        location="right"
        @click="nextPage"
      />
    </div>
  </v-sheet>
  <v-toolbar
    :collapse="hideToolbar"
    class="mainbar bottom"
    :extended="mobile ? true : false"
    :class="hideToolbar ? 'toolbar' : undefined"
  >
    <v-btn
      v-tooltip:top="`Toggle Toolbar`"
      @click="hideToolbar=!hideToolbar"
    >
      <v-icon :icon="hideToolbar ? 'fasdr fa-right-from-line' : 'fasdr fa-left-to-line'" />
    </v-btn>

    <v-btn to="/">
      <v-icon icon="fasdr fa-home" />
      <v-tooltip>
        Show Songbook Listing
        <v-hotkey keys="backspace" />
      </v-tooltip>
    </v-btn>

    <History :height="getHeight" />



    <v-divider vertical />

    <v-toolbar-title
      v-if="!mobile"
      :text="parseTitle(appStore.fileName)"
    />

    <v-divider vertical />

    <v-btn
      :disabled="firstSong"
      @click="prevSong"
    >
      <v-icon icon="fasldr fa-backward" />
      <v-tooltip>
        Prev Song
        <v-hotkey keys="pageup" />
      </v-tooltip>
    </v-btn>

    <v-menu
      v-model="showPlaylist"
      location="top left"
      :max-height="getHeight"
      width="400px"
      transition="scroll-y-transition"
    >
      <template #activator="{ props }">
        <v-btn
          variant="plain"
          v-bind="props"
          :disabled="noIndex"
        >
          <v-tooltip>
            Playlist
          </v-tooltip>
          <v-icon icon="fasdr fa-list-music" />
          <span v-if="!mobile">Songs</span>
        </v-btn>
      </template>
      <v-list
        v-model:selected="songSelect"
        color="tertiary"
        class="mainpanel"
      >
        <v-list-item class="bg-secondary">
          Tracks
          <template #append>
            <v-icon-btn
              v-tooltip:bottom="`Close Playlist`"
              icon="fasldr fa-xmark"
              @click="showPlaylist = !showPlaylist"
            />
          </template>
        </v-list-item>
        <v-list-item
          v-for="(song, n) in outlineTree"
          :key="n"
          :value="n"
          @click.prevent="gotoSong(n, song.destination as unknown as PDFDestination)"
        >
          <template #prepend>
            <v-avatar v-if="appStore.currentTrack === n">
              <v-icon icon="fasdr fa-circle-play" />
            </v-avatar>
            <v-avatar v-else>
              {{ n + 1 }}
            </v-avatar>
          </template>
          {{ song.title }}
        </v-list-item>
        <!-- </v-list> -->
      </v-list>
    </v-menu>

    <v-btn
      :disabled="lastSong"
      @click="nextSong"
    >
      <v-icon icon="fasldr fa-forward" />
      <v-tooltip>
        Next Song
        <v-hotkey keys="pagedown" />
      </v-tooltip>
    </v-btn>
    <v-divider
      vertical
      inset
    />
    <v-btn
      v-if="!mobile"
      v-tooltip:bottom="'First Page'"
      icon="fasldr fa-backward-step"
      color="secondary"
      @click="getPage(1)"
    />

    <v-btn
      v-tooltip:bottom="'Prev Page'"
      icon="fasldr fa-angle-left"
      color="secondary"
      @click="prevPage"
    />

    <v-menu :close-on-content-click="false">
      <template #activator="{ props }">
        <v-btn
          v-tooltip:bottom="'Go to Page'"
          v-bind="props"
        >
          {{ appStore.currentPage }} / {{ pages }}
        </v-btn>
      </template>
      <v-card
        width="150"
        theme="dark"
      >
        <v-card-actions>
          <v-text-field
            v-model="newPage"
            width="180"
            label="Go To Page"
            :rules="[() => newPage <= pages || 'Cannot Go Past Last Page']"
            @update:model-value="setPage(newPage)"
          />
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-btn
      v-tooltip:bottom="'Next Page'"
      icon="fasldr fa-angle-right"
      color="secondary"
      @click="nextPage"
    />

    <v-btn
      v-if="!mobile"
      v-tooltip:bottom="'Last Page'"
      icon="fasldr fa-forward-step"
      color="secondary"
      @click="getPage(pages)"
    />
    <v-spacer />

    <!-- <OCR /> -->

    <Detector />

    <Timer
      v-if="!mobile"
      @time-reached="timeCallback"
    />

    <v-divider vertical />


    <v-btn
      v-if="!mobile"
      @click="saveInfo"
    >
      <v-icon icon="fasldr fa-clipboard" />
      <v-tooltip>
        Save info
        <v-hotkey keys="ctrl+s" />
      </v-tooltip>
    </v-btn>

    <v-btn
      v-if="!mobile"
      @click="saveFile"
    >
      <v-icon icon="fasldr fa-file" />
      <v-tooltip>
        Download PDF
        <v-hotkey keys="ctrl+p" />
      </v-tooltip>
    </v-btn>

    <template
      v-if="!hideToolbar"
      #extension
    >
      <v-btn
        prepend-icon="fasldr fa-clipboard"
        @click="saveInfo"
      >
        Save info
      </v-btn>

      <v-btn
        prepend-icon="fasdr fa-file-pdf"
        @click="saveFile"
      >
        Download PDF
      </v-btn>

      <Timer
        v-if="mobile"
        @time-reached="timeCallback"
      />
    </template>
  </v-toolbar>
</template>

<script setup lang="ts">
import { VuePDF, usePDF, type PDFDestination } from "@tato30/vue-pdf";
import {
  ref,
  computed,
  triggerRef,
  watchEffect,
  watch,
  onBeforeUnmount,
  onMounted,
} from "vue";
import { useAppStore } from "../stores/app";
import "@tato30/vue-pdf/style.css";
import { useDisplay, useHotkey } from "vuetify";
import { useRoute, onBeforeRouteLeave } from "vue-router";
import { type Song, type ErrorItem } from "../components/Types";
import router from "../router";
import History from "../components/History.vue";
import Detector from "../components/Detector.vue";

const route = useRoute();
// const routeStore = useRouteStore();
const { mobile } = useDisplay();
const appStore = useAppStore();
const VPDF = ref({});
const newPage = ref(1);
const showPlaylist = ref(false);

const props = defineProps({
  file: String,
})

// const fileTarget = computed(() => {
//   return appStore.file;
// });

const pdfSource = computed(() => {
  return {
    url: appStore.file,
    wasmUrl: '/wasm/',
  };
});

const { pdf, info, pages, getPDFDestination } = usePDF(pdfSource, {
  onError: (error) => {
    console.log(error);
    appStore.setAlert({
      name: error?.name,
      message: error?.message,
      stack: error?.stack,
      status: error?.status
      })


  },
  onProgress: (prog) => {
    loadingTotal.value = prog.total;
    loadingCurrent.value = prog.loaded;
  },
});

const outlineTree = ref([] as Song[]);

const firstSong = computed(() => {
  return appStore.currentTrack === 0;
});

const lastSong = computed(() => {
  return appStore.currentTrack === outlineTree.value.length - 1;
});

const model = computed({
  get() {
    return appStore.currentPage - 1;
  },
  set(newValue) {
    appStore.setPage(newValue + 1);
  },
});

const songIndex = computed(() => {
  return appStore.currentTrack;
});

// const songSelect = computed(() => {
//   return [appStore.currentTrack];
// });

const songSelect = computed({
  get() {
    return [appStore.currentTrack];
  },
  set(newValue) {
    appStore.setTrack(newValue[0] ?? 0);
  }
})



const outlineLoaded = ref(false);
const hideToolbar = ref(false);
const errorItem = ref<ErrorItem | null>(null);
const loadingTotal = ref(0);
const loadingCurrent = ref(0);

const loadingPercent = computed(() => {
  return (loadingCurrent.value * 100) / loadingTotal.value;
});

const cleanupFunctions = ref<Array<() => void>>([]);

function setPage(page: number | string) {
  if (typeof page === "string") {
    page = parseInt(page);
  }
  appStore.setPage(page);
}

function setFileName() {
  const fileParam = (route.params as any).file;
  appStore.file = appStore.getServerRoot + fileParam + ".pdf";
  appStore.fileName = Array.isArray(fileParam)
    ? fileParam[0]
    : fileParam;
}

onMounted(() => {
  appStore.loading = true;
  cleanupFunctions.value.forEach((cleanup) => cleanup());
  cleanupFunctions.value = [];
  cleanupFunctions.value.push(
    useHotkey("ctrl+s", () => {
      saveInfo();
    })
  );
  cleanupFunctions.value.push(
    useHotkey("ctrl+p", () => {
      saveFile();
    })
  );
  cleanupFunctions.value.push(
    useHotkey("backspace", () => {
      router.push({
        name: '/'
      });
    })
  );
  cleanupFunctions.value.push(
    useHotkey("arrowleft", () => {

      prevPage();
    })
  );
  cleanupFunctions.value.push(
    useHotkey("arrowright", () => {
      nextPage();
    })
  );
  cleanupFunctions.value.push(
    useHotkey("pagedown", () => {
      if (lastSong.value !== true) {
        nextSong();
      }
    })
  );
  cleanupFunctions.value.push(
    useHotkey("pageup", () => {
      if (firstSong.value !== true) {
        prevSong();
      }
    })
  );


});

onBeforeRouteLeave(() => {
  outlineLoaded.value = false;
  appStore.setPage(1);
  appStore.setTrack(0);
  appStore.openTrack = 0;
  appStore.resetFile();
  pdf.value?.destroy();
})


onBeforeUnmount(() => {

});


watch(() => (route.params as any).file, setFileName, { immediate: true });

watchEffect(() => {
  if (
    info.value &&
    "outline" in info.value &&
    info.value.outline !== undefined
  ) {
    outlineTree.value = info.value?.outline.map(function convert(node: any): Song {
      return {
        title: node.title,
        destination: getPDFDestination(node.dest),
        items: node.items.map((item: any) => {
          return convert(item);
        }),
      };
    });


    outlineLoaded.value = true;
    appStore.loading = false;
  }
});

triggerRef(info);

const onPdfLoaded = async () => {
  appStore.loading = false;

  if (appStore.openTrack !== 0) {
    if (outlineLoaded.value === true) {
      const trackIndex = appStore.openTrack - 1;
      openSong(trackIndex);
      appStore.openTrack = 0;

    }
  }
}

watch(outlineLoaded, (loaded) => {
  if (loaded && appStore.openTrack !== 0) {
    const trackIndex = appStore.openTrack - 1;
    openSong(trackIndex);
    appStore.openTrack = 0;
  }
});

const extensionHeight = computed(() => {
  if (mobile) return 46;
  else return 0;
})

const noIndex = computed(() => {
  if (info.value && "outline" in info.value && info.value.outline?.length > 0) {
    return false;
  } else {
    return true;
  }
});

const getHeight = computed(() => {
  if (hideToolbar.value === true) return window.innerHeight;
  else return window.innerHeight - extensionHeight.value;
});

const getWidth = computed(() => {
  return window.innerWidth;
})


function loadbook(book: string) {
  appStore.currentPage = 1;

  if (book === "/")
  {
    router.push({
      name: '/'
    });
  } else {
    appStore.fileName = book.replace("/viewer/", "");
    appStore.file = appStore.getServerRoot + appStore.fileName + ".pdf";

    router.push({
      name: '/viewer',
      params: {
        file: appStore.fileName
      }
    });
  }
}

function parseTitle(book: string) {
  if (props.file !== '')
  {
    return props.file
  } else if (book.includes("-")) {
    return book
      .trim()
      .replace("-", " ")
      .replace(/\B([A-Z])\B/g, " $1");
  } else {
    return book.trim().replace(/\B([A-Z])\B/g, " $1");
  }
}

async function gotoPage(dest: PDFDestination) {
  try {
    const destination = await dest;
    appStore.currentPage = destination.pageIndex + 1;
  } catch (err: any) {
    // errorItem.value = err;
    // showError.value = true;
    appStore.setAlert({ name: err?.name, message: err?.message })
  }
}

function timeCallback() {
  nextPage();
}

async function openSong(index: number) {
  try {
    const song = outlineTree.value[index];
    if (!song) return;
    const destination = await song.destination;
    appStore.currentPage = destination.pageIndex + 1;
    appStore.setTrack(index);
  } catch (err: any) {
    appStore.setAlert({
      name: err?.name,
      message: err?.message,
      stack: err?.stack,
      status: err?.status
})
  }
}

async function gotoSong(index: number, dest: PDFDestination) {
  try {
    const destination = await dest;
    appStore.currentPage = destination.pageIndex + 1;
    appStore.setTrack(index);
  } catch (err: any) {
    appStore.setAlert({ name: err?.name,
      message: err?.message,
      stack: err?.stack,
      status: err?.status })
  }
}


function prevSong() {
  try {
    if (songIndex.value > 0) {
      appStore.setTrack(songIndex.value - 1);
      // songIndex.value--;
      const song = outlineTree.value[songIndex.value];
      if (song) {
        gotoPage(song.destination);
      }

      songSelect.value = [songIndex.value];
    }
  } catch (err: any) {
    appStore.setAlert({ name: err?.name,
      message: err?.message,
      stack: err?.stack,
      status: err?.status })
  }
}

function prevPage() {
  if (appStore.currentPage > 1) {
    appStore.currentPage--;
  }
}

function nextPage() {
  if (appStore.currentPage < pages.value) {
    appStore.currentPage++;
  }
}

function nextSong() {
  try {
    if (songIndex.value < outlineTree.value.length) {
      // songIndex.value++;
      appStore.setTrack(songIndex.value + 1);
      const song = outlineTree.value[songIndex.value];
      if (song) {
        gotoPage(song.destination);
      }
      songSelect.value = [songIndex.value];
    }
  } catch (err: any) {
    appStore.setAlert({ name: err?.name,
      message: err?.message,
      stack: err?.stack,
      status: err?.status })
  }
}

function getPage(n: number) {
  appStore.currentPage = n;
}

function saveFile() {
  try {
  const element = document.createElement("a");
  element.setAttribute("href", appStore.file);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
} catch (err: any) {
  appStore.setAlert({ name: err?.name,
      message: err?.message,
      stack: err?.stack,
      status: err?.status })
}
}

async function saveInfo() {
  try {
    if (outlineTree.value && outlineTree.value.length > 0) {
      const songListing = await Promise.all(
        outlineTree.value.map(async (o) => {
          const resolved = await o.destination;
          return {
            title: o.title,
            destination: resolved,
          };
        })
      );

      const textToWrite = JSON.stringify(songListing);

      await navigator.clipboard.writeText(textToWrite);

      const filename = appStore.fileName;
      const element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:application/json;charset=utf-8," + encodeURIComponent(textToWrite)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } else {
      appStore.setAlert({
        name: "No Outline",
        message: "Unable to create destination information",
        stack: "",
        status: 400,
      });
    }
  } catch (err: any) {
    console.log(err);
    appStore.setAlert({
      name: err?.name,
      message: err?.message,
      stack: err?.stack,
      status: err?.status,
    });
  }
}
</script>

<style lang="css" scoped>
.toolbar {
  position: fixed !important;
  z-index: 10;
  justify-self: center;
}

.pdfFile {
  height: 100dvh !important;
  max-height: 100dvh !important;
  width: auto;
}

.lds-ring,
.lds-ring div {
  box-sizing: border-box;
}
.lds-ring {
  display: inline-block;
  position: relative;
  margin-top: 100px;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid currentColor;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: currentColor transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.mainbar {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
  }

.mainpanel {
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
  border-radius: 10px;
}

.bottom {
  position: absolute;
  z-index: 1;
  bottom: 0%;

}
</style>
